<form [formGroup]="form" (submit)="submit()">
  <div class="form-group">
    <label>First Name</label>
    <input type="text" class="form-control" name="first_name" formControlName="first_name">
  </div>
  <div class="form-group">
    <label>Last Name</label>
    <input type="text" class="form-control" name="last_name" formControlName="last_name">
  </div>
  <div class="form-group">
    <label>Email</label>
    <input type="text" class="form-control" name="email" formControlName="email">
  </div>

  <div class="form-group">
    <label>Role</label>
    <select name="role_id" class="form-control" formControlName="role_id">
      <option *ngFor="let role of roles" [ngValue]="role.id">
        {{role.name}}
      </option>
    </select>
  </div>

  <button class="btn btn-outline-secondary">Save</button>
</form>

